'use client';

import { Children, Fragment, ReactNode } from 'react';
import { LayoutDefault as LayoutDefaultComponent } from '@components/layout/Layouts/LayoutDefault';

export default function LayoutNoFooter({ children, detailModal }: { children: ReactNode, detailModal: ReactNode }) {
  const layoutChildren = Children.toArray([
    <Fragment key="content-slot">{children}</Fragment>,
    <Fragment key="detail-modal-slot">{detailModal}</Fragment>,
  ]);

  return (
    <LayoutDefaultComponent hideFooter>
      {layoutChildren}
    </LayoutDefaultComponent>
  );
}
